export function resolvePostEmbedOpenMode({
    isSystemUser,
    isSystemQuest,
    isQuoteNotification,
    isLeaderboardAnnouncement,
}: {
    isSystemUser: boolean
    isSystemQuest: boolean
    isQuoteNotification: boolean
    isLeaderboardAnnouncement: boolean
}): 'permalink' | 'childQuest' {
    // Backlinks also live in ordinary song/thread replies. Open the quoting
    // post where it lives, not its optional (and often absent) reply branch.
    return isSystemUser && (isSystemQuest || isQuoteNotification) && !isLeaderboardAnnouncement
        ? 'permalink'
        : 'childQuest'
}
